import {
    Grid,
    Heading,
    Text,
    GreenInputField,
    Button,
    Flex,
} from '@raskrask-dk/rr-components'
import { ReactElement } from 'react'
import { PropsNoPartnerAvailableTemplate } from './props'
import { useAppSelector } from '../../../redux/hooks'
import { getIsMobile } from '../../../redux/reducers/appSettings'
import { PageTemplate } from '../../chemistry/skeleton'
import { useTranslation } from 'react-i18next'

const NoPartnerAvailableTemplate = ({
    basisType,
    isValidEmail,
    onChangeSignUp,
    onClickSubmit,
    basisTypes,
    selectedBasisTypes,
    onClickBasisType,
}: PropsNoPartnerAvailableTemplate): ReactElement => {
    const isMobile = useAppSelector((state) => getIsMobile(state))
    const { t } = useTranslation()
    const isSubmittable =
        isValidEmail &&
        selectedBasisTypes !== undefined &&
        selectedBasisTypes.length > 0
    return (
        <PageTemplate
            Top={
                <>
                    {basisType && (
                        <Heading bold primary size={isMobile ? 5 : 4}>
                            {t(`common:basistypes.${basisType?.id}.name`)}
                        </Heading>
                    )}

                    <Grid
                        gap={16}
                        css={{
                            m: '0 auto',
                            maxWidth: 500,
                            py: '$4',
                            textAlign: 'center',
                        }}
                    >
                        <Text primary bold size={'l'}>
                            {t('calendar.nopartneravailable.apology')}
                        </Text>
                        <Text primary>
                            {t('calendar.nopartneravailable.followup')}
                        </Text>
                        <Text>
                            {t('calendar.nopartneravailable.basistypes.header')}
                        </Text>
                        <Flex gap={16} css={{ justifyContent: 'center' }}>
                            {basisTypes.map((basisType) => {
                                return (
                                    <Button
                                        key={basisType.id}
                                        size="large"
                                        variant="option"
                                        onClick={() =>
                                            onClickBasisType(basisType.id)
                                        }
                                        active={
                                            selectedBasisTypes &&
                                            selectedBasisTypes.filter(
                                                (sbt) => sbt.id === basisType.id
                                            ).length > 0
                                        }
                                    >
                                        {basisType.name}
                                    </Button>
                                )
                            })}
                        </Flex>
                        <GreenInputField
                            buttonDisabled={!isSubmittable}
                            buttonText={t(
                                'calendar.nopartneravailable.ctabutton'
                            )}
                            onChange={onChangeSignUp}
                            onClickButton={onClickSubmit}
                            placeholder={t(
                                'calendar.nopartneravailable.emailplaceholder'
                            )}
                            showButton
                        />
                    </Grid>
                </>
            }
            Body={undefined}
            Modal={undefined}
            hideBackButton
        />
    )
}

export default NoPartnerAvailableTemplate
